<template>
    <v-container>
        <!--  标题   -->
        <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218); height: 10px;" class="ml-4 mt-2">
            烟感报警点检填报
            <v-icon></v-icon>
        </p>
        <v-icon></v-icon>
        <span class="ml-4" style="color:rgb(132, 132, 132); font-size: 12px;">根据消防点检情况进行填写</span>
        <div>

            <!-- 填报表单 -->
            <v-form ref="form" v-model="isValid">
                <v-card-text>
                    <v-row>
                        <!-- 设备类型 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_type" label="请输入设备类型" :rules="requiredRules" required
                                hint="请输入设备类型  , 首次自动填充"></v-text-field>
                        </v-col>

                        <!-- 设备数量 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
                            class="mt-1">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备数量 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_number" label="请输入巡检设备数" type="number"
                                :rules="countRules" required hint="请输入同批次类型设备点检数量"></v-text-field>
                        </v-col>

                        <!-- 点检项卡片 -->
                        <v-col cols="12" class="mt-1">
                            <v-row>
                                <!-- 点检子项标题 -->
                                <v-col cols="12" class="d-flex align-center">
                                    <v-icon style="color:rgb(240,181,68);" size="20">mdi-book-edit</v-icon>
                                    <span style="font-size: 18px; font-weight: 700; color: rgb(240,181,68);"
                                        class="ml-2">
                                        检查内容项
                                    </span>
                                </v-col>
                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 显示屏是否正常</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_one" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="显示屏是否正常：合格"></v-radio>
                                                <v-radio label="×" value="显示屏是否正常：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 报警指示灯</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_two" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="报警指示灯：合格"></v-radio>
                                                <v-radio label="×" value="报警指示灯：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 故障指示灯</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_three" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="故障指示灯：合格"></v-radio>
                                                <v-radio label="×" value="故障指示灯：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 主电指示灯</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_four" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="主电指示灯：合格"></v-radio>
                                                <v-radio label="×" value="主电指示灯：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>


                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 备电指示灯</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_five" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="备电指示灯：合格"></v-radio>
                                                <v-radio label="×" value="备电指示灯：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>


                                <v-card style="width: 100%;" class="mt-1">
                                    <div style=" width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 探测器无污渍</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_six" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="探测器无污渍：合格"></v-radio>
                                                <v-radio label="×" value="探测器无污渍：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>
                                <p class="mt-4 ml-2">维护检查须知：<br>
                                    ①每次点检确认合格时，需在相应栏目打“√”,异常时打 “×”。<br>
                                    ②正常监控状态时，显示屏：充电、主电、备电均为 “√”状态。<br>
                                    ③如有异常请及时处理。<br>
                                <p class="ml-2" style="">符合要求的项目请在所对应的框内打“√”，不符合的请打“×”，并在备注中注明具体情况。</p>
                                </p>
                            </v-row>
                        </v-col>

                        <!-- 设备结果单选框 -->
                        <v-col cols="12" class=""
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px; padding: 0;">设备状态 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-radio-group v-model="formData.check_status" label="" :rules="requiredRules" required row
                                class="d-flex align-center">
                                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;"
                                    label="正常" value="正常"></v-radio>
                                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;"
                                    label="异常" value="异常"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- 设备楼栋 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
                            class="mt-1">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">点检楼栋 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_buliding" label="请输入设备楼宇" :rules="requiredRules" required
                                hint="请输入设备楼宇"></v-text-field>
                        </v-col>

                        <!-- 设备楼层 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
                            class="mt-1">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">点检楼层 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_floor" label="请输入设备楼层" :rules="requiredRules" required
                                hint="请输入设备楼层"></v-text-field>
                        </v-col>

                        <!-- 设备描述 -->
                        <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">点检情况描述 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-textarea v-model="formData.check_description" label="设备异常情况说明" :rules="requiredRules"
                                required hint="设备异常情况说明"></v-textarea>
                        </v-col>

                        <!-- 上传现场图片 -->
                        <v-col cols="12" sm="6" md="4" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">上传附件 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-file-input v-model="check_attachment" label="上传现场图片" accept="image/*" required
                                hint="支持上传图片、PDF、Word文档" @change="uploadImage(check_attachment)"
                                :rules="[v => !!v || '请上传一张图片']">
                                <!-- @update:model-value="handleFileInput" -->
                            </v-file-input>
                            <v-img v-if="imageUrl" :src="imageUrl" aspect-ratio="1" class="mt-4"
                                max-width=""></v-img>
                        </v-col>


                        <!-- 巡检人员信息标题 -->
                        <v-col class="d-flex align-center float-left mt-4" style="height:40px;">
                            <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218);">
                                <v-icon style="color: rgb(50,134,218);">mdi-account-circle</v-icon>
                                巡检人员信息
                            </p>
                        </v-col>

                        <!-- 巡检人 -->
                        <v-col cols="12" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查人员 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_staff" label="请输入检查人员" :rules="requiredRules" required
                                hint="请输入检查人员"></v-text-field>
                        </v-col>

                        <!-- 巡检部门 -->
                        <v-col cols="12" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查部门 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_department" label="请输入检查部门/组" :rules="requiredRules"
                                required hint="请输入检查部门/组"></v-text-field>
                        </v-col>

                        <!-- 巡检时间 -->
                        <v-col cols="12" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px;">检查时间 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_date" label="" readonly
                                hint="自动填充当前时间"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-around">
                    <v-btn color="success" dark @click="resetForm">重置</v-btn>
                    <!-- <v-spacer></v-spacer>   -->
                    <v-btn color="blue darken-1" dark @click="submitForm">提交</v-btn>
                </v-card-actions>
            </v-form>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'smokeDetector',
    data() {
        return {
            isValid: false,                                 // 填报表单的状态
            formData: {
                check_id: '',                               // 设备编号
                check_type: '烟感报警',                      // 设备类型
                check_number: '',                           // 点检设备数量
                check_task_item_one: '',                     // 点检子项(1项)
                check_task_item_two: '',                     // 点检子项(1项)
                check_task_item_three: '',                   // 点检子项(1项)
                check_task_item_four: '',                    // 点检子项(1项)
                check_task_item_five: '',                    // 点检子项(1项)
                check_task_item_six: '',                     // 点检子项(1项)
                check_status: '',                           // 设备状态
                check_buliding: '',                         // 设备楼宇
                check_floor: '',                            // 设备楼层
                check_description: '',                      // 设备详情描述
                check_attachment: null,                     // 上传图片附件
                check_staff: '',                            // 巡检人员
                check_department: '',                       // 巡检部门
                check_date: '',                             // 巡检时间
            },
            imageUrl: null,
            requiredRules: [v => !!v || '该字段是必填项'],  // 正则判断
            requiredRadio: [value => !!value || '该字段是必填项'],
            countRules: [v => !!v || '该字段是必填项', v => /^\d+$/.test(v) || '请输入有效的数字']

        }
    },
    mounted() {
        // 初始化进入表单时读取当前系统时间进行传给表单填报时间
        this.initializeTime();
    },
    methods: {
        // 格式化时间
        async initializeTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const day = now.getDate();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const seconds = now.getSeconds();
            // 添加前导零  
            const formattedMonth = month < 10 ? '0' + month : month.toString();
            const formattedDay = day < 10 ? '0' + day : day.toString();
            const formattedHours = hours < 10 ? '0' + hours : hours.toString();
            const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
            const formattedSeconds = seconds < 10 ? '0' + seconds : seconds.toString();
            const formattedDateTime = `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
            this.formData.check_date = formattedDateTime;

            return formattedDateTime;
        },

        async submitForm() {
            console.log('填报的数据信息', this.formData);
            if (this.isValid) {
                try {
                    await this.submitFormData();
                    this.showSucceSnackbar("填报成功。");
                } catch (error) {

                }

            }
        },
        // 拼接图片和字段文本内容直接提交
        async submitFormData() {
            try {
                // const imageUrl = await this.uploadImage(this.formData.abnormal_attachment);
                const textData = {
                    check_type: this.formData.check_type,
                    check_number: this.formData.check_number,
                    check_task_item_one: this.formData.check_task_item_one,
                    check_task_item_two: this.formData.check_task_item_two,
                    check_task_item_three: this.formData.check_task_item_three,
                    check_task_item_four: this.formData.check_task_item_four,
                    check_task_item_five: this.formData.check_task_item_five,
                    check_task_item_six: this.formData.check_task_item_six,
                    check_status: this.formData.check_status,
                    check_buliding: this.formData.check_buliding,
                    check_floor: this.formData.check_floor,
                    check_description: this.formData.check_description,
                    check_attachment: this.imageUrl,
                    check_staff: this.formData.check_staff,
                    check_department: this.formData.check_department,
                    check_date: this.formData.check_date,
                };
                console.log('拼接表单字段内容', textData);
                const jsonData = JSON.stringify(textData);

                console.log(jsonData);
                const response = await fetch('http://192.168.3.3:18081/check/addCheckSmoke', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: jsonData,
                });
                if (!response.ok) {
                    throw new Error("提交失败!");
                }
                console.log("提交成功!");
                this.$router.push("/logoView");


            } catch (error) {
                console.error('提交过程中发生错误：', error);
                this.showErrorSnackbar('提交失败，请检查网络或数据格式');
            }
        },


        // 上传图片,回传保存后的图片Url
        async uploadImage(check_attachment) {
            const formData = new FormData();
            const file = check_attachment;
            console.log("上传图片获取的地址", file)
            if (file) {
                formData.append('check_attachment', file);
            }
            try {
                const response = await fetch('http://192.168.3.3:18081/check/files/upload/image', {
                    method: 'POST',
                    body: formData,
                });
                if (!response.ok) {
                    throw new Error('图片上传失败!');
                }
                const data = await response.json();
                const userData = data.data;
                this.imageUrl = userData;
                console.log("图片上传成功,地址:", this.imageUrl);
                return this.imageUrl;
            } catch (error) {
                console.error("图片上传失败!", error);
                throw error;
            }
        },

        // 上传表单文本
        // async submiTextData(textData) {
        //   const jsonData = JSON.stringify(textData);
        //   console.log(jsonData);
        //   const response = await fetch('http://127.0.0.1:18080/abnormal/addAbnormal', {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        //     body: jsonData,
        //   });
        //   console.log(response);
        //   // return response;
        // },
        // 重置表单数据逻辑
        async resetForm() {
            // this.$refs.form.reset();
            const currentTime = await this.initializeTime();
            this.formData = {
                check_type: '烟感报警',                       // 设备类型
                check_number: '',                            // 点检设备数量
                check_task_item_one: '',                      // 点检子项(1项)
                check_task_item_two: '',                      // 点检子项(2项)
                check_task_item_three: '',                    // 点检子项(3项)
                check_task_item_four: '',                     // 点检子项(4项)
                check_task_item_five: '',                     // 点检子项(5项)
                check_task_item_six: '',                      // 点检子项(6项)
                check_status: '',                            // 设备状态
                check_buliding: '',                          // 设备楼宇
                check_floor: '',                             // 设备楼层
                check_description: '',                       // 设备详情描述
                check_attachment: null,                      // 上传图片附件
                check_staff: '',                             // 巡检人员
                check_department: '',                        // 巡检部门
                check_date: currentTime,                     // 巡检时间
            },
                this.imageUrl = null;
        }
    }
}
</script>